export default {
  "custom": {
    linkedReference: 'Riferimento collegato',
    boot: 'Accendi',
    shutDown: 'Spegni',
    notLinked: 'Non collegato',
    maxLinkedTip: 'Sono consentiti al massimo 2 collegamenti {type}, ripristinato automaticamente a Non collegato',

    bar_Power: 'Alimentazione',
    bar_Video: 'Selettore video',
    bar_Vol: 'Volume',
    bar_Audio: 'Selettore audio',
    bar_Serial: 'Controllo seriale',
    bar_Air: 'Condizionatore',
    bar_Projection: 'Schermo di proiezione',
    bar_Remote: 'Telecomando',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Devi selezionare tutte e tre le immagini contemporaneamente',
    notSelected: 'Non selezionato',
    choose: 'Scegliere',
    disable: 'Disabilitare',
    "longPressAndDrag": "Premi a lungo e trascina per regolare l'ordine dell'elenco",
    "isrestoreDefault": "Vuoi ripristinare lo stato predefinito?",
    "saveAndSync": "Salva e sincronizza",
    "restoreDefault": "Ripristina predefinito",
    "limitPNG": "È possibile caricare solo immagini PNG!",
    "limit1M": "La dimensione dell'immagine non può superare 1 MB!",
    "selectTheImage": "Seleziona immagine",
    "textsuggestions": "Consigliato: icona PNG bianca 48*48 px, inferiore a 1 MB",
    "iconLibrary": "Libreria di icone",
    "panelNavigationBarCustomization": "Barra di navigazione del pannello",
    "logoCustomization": "Logo del pannello"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Associazione non riuscita: questo tenant Microsoft (ID: ',
    AuthVerify4004Two: ') è già utilizzato dall’organizzazione [',
    AuthVerify4004Three: ']. Per ricollegarlo, scollegalo prima dall’organizzazione originale o usa un altro tenant Microsoft.',
    theMicrosoftTenantIsOccupied: 'Il tenant Microsoft è già in uso',
    Viewtutorial: "Visualizza tutorial collegamento",
    checktenantID: "Verifica che il tuo ID tenant, ID applicazione e chiave applicazione siano corretti.",
    ErrorCode: "Codice errore:",
    AuthorizationFailed: "Autorizzazione fallita",
    Accesshasbeengranted: "Accesso all'API Microsoft Graph concesso",
    successfullyauthorizedDescribe: "Le autorizzazioni richieste sono state concesse con successo. I dati della sala riunioni verranno sincronizzati automaticamente. Chiudi questa pagina.",
    Close: "Chiudi",
    resourceID: "ID risorsa",
    dialogTips: "Suggerimenti",
    theAuthorizationIsDeleted: "Autorizzazione rimossa",
    theBindingIsSuccessful: "Collegamento riuscito",
    theUnbindingIsSuccessful: "Scollegamento riuscito",
    unbindingFailed: "Scollegamento fallito",
    theUnbindingHasBeenUnbound: "Scollegamento annullato",
    continueUnbinding: "La sincronizzazione con Outlook si interromperà e tutti gli eventi futuri verranno eliminati. Continuare con lo scollegamento?",
    areYouSureAboutUnbinding: "Tutti gli eventi futuri di Outlook verranno eliminati e la sincronizzazione si interromperà. Questa azione non può essere annullata. Confermi lo scollegamento?",
    UnbindNotSynchronized: "Dopo il collegamento, i nuovi eventi Outlook per questa sala verranno sincronizzati automaticamente (gli eventi passati non verranno sincronizzati)",
    unbinding: "Scollega",
    bindUnableToSelect: "Già collegato, selezione non disponibile",
    permissAThird: "Autorizza il collegamento a risorse di terze parti",
    resourceMailbox: "Cassetta postale risorsa:",
    PleasecheckID: "Autorizzazione fallita! Verifica che il tuo ID tenant, ID applicazione e segreto client siano corretti.",
    Waitingforauthorization: "In attesa di autorizzazione...",
    Pleasecompletetheauthorization: "Pagina di accesso Microsoft 365 aperta. Accedi con un account amministratore per completare l'autorizzazione.",
    pleaseEnterTheTenantID: "Inserisci ID tenant",
    pleaseEnterTheClientID: "Inserisci ID applicazione",
    pleaseEnterTheClientSecret: "Inserisci segreto client",
    Authorizationcompleted: "Autorizzazione completata",
    Authorizelogin: "Autorizza accesso Microsoft 365",
    ApplicationID: "ID tenant",
    ClientID: "ID applicazione",
    ClientSecret: "Segreto client",
    registTipOne: "Segui la",
    registTipTwo: "Guida al collegamento",
    registTipThree: "Completa la registrazione dell'app Azure e le impostazioni delle autorizzazioni prima di compilare i campi sottostanti.",
    MicrosoftDescribe: "Collegando Microsoft 365, le riunioni prenotate in Outlook/Teams verranno automaticamente sincronizzate con la Console Q-NEX e con lo Scheduler Sale.",
    Addcalendarservice: "Impostazioni sincronizzazione calendario",
    Lasttimesynchronization: "Ultima sincronizzazione",
    Allocated: "Assegnato",
    Total: "Totale",
    Conferenceroomresources: "Risorse sale riunioni",
    Bindingtime: "Ora collegamento",
    Bindtheplatform: "Piattaforma collegamento",
    Synchronousstate: "Stato sincronizzazione",
    Organizationname: "Nome organizzazione",
    Bindthirdpartycalendar: "Collega calendario terze parti",
    TenantIDTip: "Identificativo univoco in Azure AD",
    ApplicationIDTip: "ID applicazione registrato in Azure",
    ApplicationSecretTip: "Segreto client generato in Azure per l'autenticazione"
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Testo visualizzato in inattività',
    IdleDisplayText: 'Testo visualizzato in inattività:',
    IdleDisplayTextContent: 'Testo mostrato quando la sala è vuota (predefinito: “Libera”)',

    duplicateMeetingRoomName: 'Nome sala riunioni duplicato',
    duplicateMeetingRoomNameContent: 'Esiste già una sala riunioni denominata "{duplicate_content}". Inserisci un altro nome.',
    NumberOfRoomPanels: 'Numero di pannelli della sala',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "Il terminale attuale è già associato a un'altra organizzazione.",
    "theTerminalNameOrIDIsDuplicated": "Il nome o l'ID del pannello è lo stesso",
    theRoomNameOrIDIsDuplicated: 'Il nome della sala riunioni o la posizione è già esistente.',
    "AddMeetingRoom": "Aggiungi sala riunioni",
    "EditMeetingRoom": "Modifica sala riunioni",
    "MeetingRoomName": "Nome sala riunioni:",
    "Location": "Posizione:",
    "ReservationApproval": "Approvazione prenotazione:",
    "ApprovalListYes": "sì",
    "ApprovalListNo": "no",
    "Capacity": "Capacità:",
    "RoomStatus": "Stato della sala:",
    "BindRoomDisplay": "Collega pannello sala:",
    "meeting_btnAdd": "Aggiungi",
    "meeting_btnEdit": "Modifica",
    "meeting_btnBind": "Collega dispositivo",
    "meeting_btnDel": "Elimina",
    "meeting_tableRoomName": "Nome sala riunioni",
    "meeting_tableRoomPlace": "Posizione",
    "meeting_tableAppointmentApproval": "Approvazione prenotazione",
    "meeting_tableCapacityForPeople": "Capacità",
    "meeting_tableMeetingRoomStatus": "Stato della sala",
    "meeting_tableAvaliable": "Disponibile",
    "meeting_tableOutofService": "Fuori servizio",
    "meeting_tableDoorBind": "Collegamento porta",
    "meeting_tableBindNPS": "Collega NPS",
    "meeting_tableActions": "Azioni",
    "door_theNameOfTheTerminal": "Nome pannello:",
    "door_deviceID": "ID pannello:",
    "door_Wallpaper": "Sfondo:",
    "door_Wallpaper_text": "Immagine consigliata: dimensione 1280x800, in formato PNG",
    "door_bindAMeetingRoom": "Collega sala riunioni:",
    "door_table_name": "Nome pannello",
    "door_table_deviceID": "ID pannello",
    "door_table_status": "Stato",
    "door_table_ipAddress": "Indirizzo IP",
    "door_table_bindAMeetingRoom": "Collega sala riunioni",
    "door_btnAdd": "Aggiungi",
    "door_btnBatchAdd": "Aggiungi in batch",
    "door_btnEdit": "Modifica",
    "door_btnBatchEdit": "Modifica in batch"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Aggiungi configurazione",
    "configurationEditTitle": "Modifica configurazione",
    "dialogConfigName": "Nome configurazione",
    "selectNMPAndNDP": "Dispositivi di destinazione",
    "powerControl": "Controllo energia",
    "executeCommand": "Fai",
    "tableConfigName": "Nome configurazione",
    "selectConfig": "Seleziona configurazione"
  },
  "NPS": {
    "Relay": "Relè",
    "RelaySettings": "Impostazioni del relè",
    "DevicePower": "Controllo energia dispositivo",
    "DeviceElevation": "Controllo elevazione",
    "LinageWithNPSPower": "Collegamento con alimentazione NPS",
    "PresentationSwitch": "Interruttore di presentazione",
    "Duplicate": "Duplicato",
    "LinkagewithNPSPowe": "Collegamento con alimentazione NPS"
  },
  "PTZ": {
    "powerSupplyON": "Accensione",
    "powerSupplyOFF": "Spegnimento",
    "LEFT": "SINISTRA",
    "RIGHT": "DESTRA",
    "UP": "SU",
    "DOWN": "GIÙ",
    "HOME": "HOME",
    "ENLARGE": "INGRANDIRE",
    "REDUCTION": "RIDURRE",
    "StopMovement": "Ferma Movimento",
    "STOP": "Ferma Zoom",
    "FOCUS": "Messa a fuoco",
    "SET_PRESETS0": "IMPOSTA_PRESET0",
    "SET_PRESETS1": "IMPOSTA_PRESET1",
    "SET_PRESETS2": "IMPOSTA_PRESET2",
    "SET_PRESETS3": "IMPOSTA_PRESET3",
    "SET_PRESETS4": "IMPOSTA_PRESET4",
    "SET_PRESETS5": "IMPOSTA_PRESET5",
    "SET_PRESETS6": "IMPOSTA_PRESET6",
    "SET_PRESETS7": "IMPOSTA_PRESET7",
    "SET_PRESETS8": "IMPOSTA_PRESET8",
    "SET_PRESETS9": "IMPOSTA_PRESET9",
    "USE_PRESETS0": "USA_PRESET0",
    "USE_PRESETS1": "USA_PRESET1",
    "USE_PRESETS2": "USA_PRESET2",
    "USE_PRESETS3": "USA_PRESET3",
    "USE_PRESETS4": "USA_PRESET4",
    "USE_PRESETS5": "USA_PRESET5",
    "USE_PRESETS6": "USA_PRESET6",
    "USE_PRESETS7": "USA_PRESET7",
    "USE_PRESETS8": "USA_PRESET8",
    "USE_PRESETS9": "USA_PRESET9"
  },
  "schedule": {
    "startLinkPowerStart": "Accensione (Relè CBXs)",
    "startLinkPowerStop": "Spegnimento (Relè CBXs)",
    "dehumidification": "Secco",
    "airSupply": "Ventola",
    "masterControl": "principale:",
    "powerSupply": "Potenza",
    "lockScreen": "Blocco",
    "RecordingControl": "Controllo registrazione",
    "RecordingControlSystem": "Sistema di registrazione conferenze",
    "LiquidCrystal": "Pannello piatto interattivo",
    "projector": "Proiettore",
    "othertype": "Altro",
    "childLock": "Blocco bambino",
    "energySaving": "Risparmio energetico",
    "signalSourceSwitching": "Fonte di ingresso",
    "other": "Altre caratteristiche:",
    "otherFunction": "Funzione",
    "send": "Invia",
    "ON": "ACCESO",
    "OFF": "SPENTO",
    "btnAddSchedule": "Ripristina",
    "EditSchedulelist": "Modifica pianificatore",
    "AddSchedulelist": "Aggiungi pianificatore",
    "RestoreSchedulelist": "Ripristina",
    "btn": "Annulla",
    "btnNewList": "Nuovo pianificatore",
    "ListName": "Nome",
    "Cannotquit": "Obbligatorio",
    "NOCannotquit": "NO",
    "ListValidityPeriod": "Periodo di validità",
    "ListDescription": "Descrizione",
    "currentSchedule": "Elenco pianificatori",
    "historySchedule": "Elenco storico",
    "selectTime": "Orario",
    "taskType": "Tipo di attività",
    "selectBroadcasting": "Trasmissione",
    "selectDeviveControl": "Controllo dispositivi",
    "newSchedule": "Nuova attività",
    "newChecklist": "Nuovo elenco di controllo",
    "titleStatus": "Stato",
    "titleType": "Tipo",
    "titleStartTime": "Ora di inizio",
    "titleEndTime": "Ora di fine",
    "titleRepeat": "Ripeti",
    "titleName": "Nome",
    "titleAction": "Azione",
    "tableEnabled": "Abilitato",
    "tablePaused": "In pausa",
    "tableEdit": "Modifica",
    "tableDelete": "Elimina",
    "tableVolumeEdit": "Volume trasmissione",
    "tableBroadcastTitle": "Titolo",
    "tableBroadcastContent": "Contenuto",
    "tableBroadcastList": "Elenco",
    "tableBroadcast": "Obbligatorio",
    "btnRemoveCompletely": "Rimuovi completamente",
    "btnEnabled": "Abilitato",
    "btnPaused": "In pausa",
    "btnDelete": "Elimina",
    "repeat0": "LUN",
    "repeat1": "MAR",
    "repeat2": "MER",
    "repeat3": "GIO",
    "repeat4": "VEN",
    "repeat5": "SAB",
    "repeat6": "DOM",
    "dialogTitleAdd": "Nuova attività di controllo dispositivi",
    "dialogTitleEdit": "Modifica attività di controllo dispositivi",
    "newBroadcastingSchedule": "Nuova attività di trasmissione",
    "editBroadcastingSchedule": "Modifica attività di trasmissione",
    "chooseDevice": "Scegli dispositivo",
    "timeSetting": "Impostazione orario",
    "controlBroadcasting": "Opzione di trasmissione",
    "controlOption": "Opzione di controllo",
    "scheduleName": "Nome attività:",
    "destination": "Destinazione",
    "timeTilte": "Ora",
    "repeatTitle": "Ripeti",
    "dialogRepeat0": "LUN",
    "dialogRepeat1": "MAR",
    "dialogRepeat2": "MER",
    "dialogRepeat3": "GIO",
    "dialogRepeat4": "VEN",
    "dialogRepeat5": "SAB",
    "dialogRepeat6": "DOM",
    "dialogOnceType": "Una volta",
    "dialogRepeatType": "Ripeti",
    "mainPower": "Potenza principale",
    "powerControl": "Controllo potenza",
    "tableDisplayInputSwitch": "Interruttore ingresso display",
    "tableAirConditioning": "Condizionatore d'aria",
    "tableProjectionScreen": "Schermo di proiezione",
    "tableElectronicLock": "Blocco elettrico",
    "interactiveFlatPanel": "Pannello piatto interattivo",
    "displayInputSwitch": "Interruttore ingresso display",
    "speakerVolume": "Volume altoparlante",
    "MICVolume": "Volume microfono",
    "ProjectionScreen": "Schermo di proiezione",
    "ElectronicLock": "Blocco elettrico",
    "AirConditioning": "Condizionatore d'aria",
    "AirConditioningPower": "Potenza",
    "AirConditioningModel": "Modello",
    "AirConditioningTEMP": "TEMP",
    "AirConditioningFanSpeed": "Velocità ventilatore",
    "OPEN": "APRI",
    "CLOSE": "CHIUDI",
    "UP": "SU",
    "DOWN": "GIÙ",
    "PowerOFF": "SPENTO",
    "PowerON": "ACCESO",
    "ModelAuto": "Auto",
    "ModelCool": "Raffredda",
    "ModelHeat": "Riscalda",
    "ModelAir": "Lato aria",
    "TEMPLow": "Basso",
    "TEMPMiddle": "Medio",
    "TEMPHigh": "Alto",
    "btnSave": "Salva",
    "btnNext": "PROSSIMO",
    "StartTime": "Ora di inizio",
    "StopTime": "Ora di fine",
    "Mandatory": "Obbligatorio",
    "Video": "Video&Audio",
    "Notification": "Notifica",
    "btnFile": "Seleziona un file multimediale",
    "LastingTime": "Durata",
    "textTitle": "Titolo",
    "textContent": "Contenuto",
    "textTitleLetters": "Meno di 60 lettere",
    "textContentLetters": "Meno di 320 lettere",
    "CannotquitYES": "SÌ",
    "CannotquitNo": "No",
    "YES": "SÌ",
    "No": "No",
    "delTitleContent": "Sei sicuro di voler eliminare questo pianificatore?",
    "delTitleListContent": "Il pianificatore eliminato verrà spostato nell'elenco storico e può essere ripristinato",
    "deleListTitle": "Eliminare il pianificatore?",
    "delTitleListContent1": "Eliminare il pianificatore comporterà l'eliminazione delle attività associate, confermare.",
    "deleListTitle1": "Sei sicuro di voler eliminare questo pianificatore?",
    "delTitle": "Elimina?",
    "btnConfirm": "Conferma",
    "coxAll": "TUTTO",
    "coxBroadcasting": "Trasmissione",
    "coxDeviveControl": "Controllo dispositivi",
    "rdMandatory": "SÌ",
    "noRdMandatory": "NO",
    "startDate": "Data di inizio",
    "endedDate": "Data di fine",
    "or": "-",
    "broadcastingType": "Tipo",
    "ChooseTime": "Scegli orario",
    "ChooseDate": "Scegli data",
    "newScheduleList": "Nuovo pianificatore",
    "editScheduleList": "Modifica pianificatore",
    "listName": "Nome",
    "listValidityPeriod": "Periodo di validità",
    "listDescription": "Descrizione",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "addSuccess": "Aggiunto con successo!",
    "addError": "Aggiunta fallita!",
    "editSuccess": "Modificato con successo!",
    "editError": "Modifica fallita!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Eliminazione fallita!",
    "restoreSuccess": "Elenco pianificatori ripristinato con successo",
    "restoreError": "Ripristino dell'elenco pianificatori fallito",
    "restoreTitleContent": "Questo orario è in conflitto con l'orario del pianificatore nell'elenco, selezionare di nuovo",
    "Enabled": "Abilitato",
    "Paused": "In pausa",
    "Title": "Titolo:",
    "Content": "Contenuto:",
    "errorScheduleNameRequired": "Il nome dell'attività deve essere compilato",
    "errorDeviceRequired": "Seleziona il dispositivo di destinazione",
    "deleTitle": "Sei sicuro di voler eliminare questa attività?",
    "loopList": "Elenco loop",
    "errorPleaseDateRange": "Seleziona un intervallo di date",
    "addError_2009": "Nome pianificatore duplicato",
    "conflicts": "L'orario dell'attività è in conflitto con il seguente:",
    "Pleaseagain": "Inserisci di nuovo",
    "errorScheduleName": "Nome attività",
    "errorListName": "Nome pianificatore",
    "today": "Oggi",
    "yesterday": "Ieri",
    "thisWeek": "Questa settimana",
    "lastWeek": "Settimana scorsa",
    "lastMonth": "Ultimo mese",
    "thisMonth": "Questo mese",
    "times": "Volte",
    "TimeConflicts": "Conflitti orario",
    "editError_2006": "Dispositivo non trovato",
    "editError_2010": "Nome attività duplicato",
    "ListTimeExpired": "Il tempo del pianificatore è scaduto, selezionare di nuovo",
    "TimeExpired": "Tempo scaduto",
    "ControlOption": "Opzione di controllo mancante",
    "Pleaseleastone": "Seleziona almeno un'opzione di controllo",
    "Enter": "Inserisci",
    "TitleFilled": "Il titolo deve essere compilato",
    "ContentFilled": "Il contenuto deve essere compilato",
    "PleaseMediaFile": "Seleziona un file multimediale",
    "PleaseSchedule": "Seleziona un'attività",
    "delTitleScheduleContent": "L'attività eliminata non può essere recuperata.",
    "deleTitleSchedule": "Sei sicuro di voler eliminare questa attività?",
    "deleteScheduleTitle": "Seleziona l'attività da eliminare",
    "PleaseFillColumn": "Compila il nome del pianificatore",
    "PleaseDate": "Seleziona la data",
    "Previous": "Precedente",
    "RemoteControl": "Controllo remoto",
    "taskhasexpired": "Questa attività è scaduta, contatta il creatore per aggiornare l'orario.",
    "execute": "Esegui",
    "broadcastingList": "Elenco trasmissione",
    "volumeSuccess": "Volume impostato correttamente",
    "volumeFailed": "Impostazione del volume fallita"
  },
  "Automation": {
    "nameDuplicate": "Nome attività duplicato automatica",
    "Automation": "Automazione",
    "if": "Se:",
    "ifContent": "La sezione 'SE' ti consente di impostare condizioni basate sui dati dei sensori. Scegli il sensore e specifica condizioni come 'Temperatura > 26°C'.",
    "then": "Allora:",
    "thenContent": "La sezione 'ALLORA' ti consente di scegliere dispositivi e definire azioni per essi. Seleziona dispositivi come NMP1, NMP2 e specifica azioni come 'Accendi + Raffredda' per i condizionatori d'aria.",
    "btnDelete": "Elimina",
    "Add": "Aggiungi",
    "taskName": "Nome attività",
    "dialogTaskName": "Nome attività:",
    "Statue": "Stato",
    "DevicesApplied": "Dispositivi applicati",
    "Operation": "Operazione",
    "AirConditioningPower": "Potenza",
    "AirConditioningModel": "Modello",
    "AirConditioningFanSpeed": "Velocità ventilatore",
    "bold": "Oscillazione",
    "selectTask": "Seleziona attività",
    "autoTaskAdd": "Aggiungi attività di automazione",
    "autoTaskEdit": "Modifica attività di automazione",
    "Destination": "Destinazione",
    "selectConditions": "Si prega di specificare l'azione che desideri eseguire.",
    "selectDestination": "Seleziona il dispositivo NMP di destinazione, quindi specifica l'azione che desideri eseguire",
    "AirConditioningTEMP": "Temperatura",
    "AirConditioningHumidness": "Umidità",
    "noData": "Nessuna attività aggiunta ancora. Clicca sul pulsante \"Aggiungi\" per aggiungere attività."
  },
  "rs232Translation": {
    "reliveBinding": "Scollega",
    "RELIVEBINDING": "Scollega",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "Il nome del CBX non può essere vuoto",
    "BrandNoNull": "Il marchio non può essere vuoto",
    "ModelNoNull": "Il modello non può essere vuoto",
    "AcNoNull": "Il controllo A/C non può essere vuoto",
    "RcNoNull": "Il telecomando non può essere vuoto"
  },
  "route": {
    customize: 'Personalizza',
    "InputSourcesLinkage": "Collegamento Fonti di Input",
    "Automation": "Automazione",
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "organizationMge": "Gruppi",
    "userMge": "Utenti",
    "authorityMge": "Permessi",
    "roleMge": "Ruoli",
    "equipmentMge": "Dispositivi",
    "workstationMge": "Media Server",
    "cloudDiskMge": "Memorizzazione",
    "operationLog": "Registro delle Operazioni",
    "setting": "Impostazioni",
    "resourceMge": "Gestione delle Risorse",
    "storageMge": "Gestione dello Spazio di Archiviazione",
    "interfaceRename": "Rinomina Interfaccia",
    "processorManager": "Gestore del Processore",
    "projectorCode": "Gestione Codici Seriali",
    "projectorCodeSetting": "Impostazioni Codici Seriali",
    "RepairLog": "Registro Riparazioni",
    "remoteControl": "Codice di Controllo Remoto",
    "acCode": "Codice di Controllo A/C",
    "cardMge": "Carte",
    "cardLog": "Registro Utilizzo Carte",
    "cardManager": "Gestore Carte",
    "meetingManager": "Riunione",
    "meetingRoomManager": "Gestione Stanze",
    "meetingDoorManager": "Gestione Pannelli"
  },
  "navbar": {
    "logOut": "Esci",
    "dashboard": "Dashboard",
    "screenfull": "Schermo intero",
    "language": "Lingua",
    "userConsole": "Console Q-NEX",
    "BackTianwa": "Torna a Tianwa"
  },
  "feedback": {
    "Feedback": "Feedback",
    "email": "Per favore lascia la tua email per il nostro feedback.",
    "content": "Benvenuto e lascia messaggi per migliorare i nostri prodotti. Grazie per i tuoi commenti.",
    "submit": "Invia",
    "emailNoEmpty": "L'email non può essere vuota",
    "emailTrueRule": "Inserisci il formato email corretto",
    "contentNoEmpty": "Il contenuto non può essere vuoto",
    "feedbackSuccess": "Feedback riuscito",
    "feedbackFailed": "Feedback fallito",
    "emailNoChinese": "La casella di posta non può contenere caratteri cinesi",
    "emailLength": "Tra 5 e 100 caratteri di lunghezza",
    "GroupNameLength": "Tra 1 e 20 caratteri di lunghezza",
    "emailSpecialString": "Questa casella di input non può contenere stringhe speciali"
  },
  "login": {
    "title": "BENVENUTO",
    "logIn": "Accedi",
    "username": "Nome utente",
    "password": "Password",
    "any": "qualsiasi",
    "thirdparty": "Oppure connettiti con",
    "thirdpartyTips": "Non può essere simulato in locale, quindi per favore combina la tua simulazione aziendale!",
    "placeholder": "[ \n  \"Nome Utente\",\n  \"Password\",\n  \"Codice di verifica\"\n]",
    "userNameTitle": "Nome utente errato!",
    "forget": "Dimenticato?",
    "loginTitle0": "Accesso riuscito!",
    "loginTitle1000": "Nome utente o password errati!",
    "loginTitle1001": "Il nome utente e la password devono essere compilati!",
    "loginTitle1002": "Il codice di verifica deve essere compilato!",
    "loginTitle1003": "Lo stato dell'utente è illegale, accesso fallito!",
    "loginTitle1004": "Errore nel codice di verifica!",
    "loginTitle1005": "Non hai effettuato il login, effettua il login prima!",
    "loginTitleUserName": "Il nome utente deve essere compilato!",
    "loginTitlePwd": "La password deve essere compilata!",
    "loginTitleVercode": "Il codice di verifica deve essere compilato!",
    "errorLogin": "Diritti utente insufficienti, impossibile effettuare il login!",
    "titleLoginNameFormat": "Deve essere composto da caratteri, o caratteri e numeri."
  },
  "organizationMge": {
    "CanTDragTop": "Impossibile spostarsi nella radice",
    "prefixCannotBeEmpty": "Il prefisso dell'account super amministratore non può essere vuoto",
    "enterEnglishLetters": "Il prefisso dell'account super amministratore può contenere solo lettere e numeri in inglese",
    "dateNotSelected": "La data di inizio del periodo di validità del servizio di streaming non è selezionata",
    "btnAddChild": "Aggiungi subordinato",
    "btnAddSibling": "Aggiungi fratello",
    "title": "Suggerimento:",
    "againTitle": "Si prega di confermare di nuovo:",
    "sort": "Ordina:",
    "realName": "Nome completo:",
    "titleShooleRq": "Questo campo deve essere compilato",
    "titleShooleNub": "Meno di 100 lettere",
    "schoolName": "Nome del gruppo:",
    "type": "Tipo di gruppo:",
    "accountPrefix": "Account amministratore:",
    "organization": "Distributore",
    "terminalMechanism": "Utente finale",
    "equipmentNum": "Numero dispositivi:",
    "organizationNum": "Numero gruppi terminali:",
    "adminName": "Account amministratore:",
    "adminPwd": "Password amministratore:",
    "edit": "Modifica",
    "add": "Aggiungi",
    "del": "Elimina",
    "addSuccess": "Aggiunto con successo",
    "addError": "Aggiunta fallita!",
    "editSuccess": "Modifica riuscita",
    "editError": "Modifica fallita!",
    "delSuccess": "Eliminato con successo!",
    "delWarn": "Impossibile eliminare questo gruppo con dispositivi associati",
    "delError": "Eliminazione fallita!",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "TrialWorkstation": "Attualmente sei in stato di prova, che consente solo di trasmettere e trasmettere in diretta a 3 dispositivi terminali al massimo.",
    "Normal": "Normale",
    "NormalWorkstation": "Il periodo di validità del tuo servizio di streaming è dal",
    "to": "al",
    "Advent": "Avvento",
    "AdventWorkstationOne": "Il tuo servizio di streaming scadrà il",
    "AdventWorkstationTwo": ", contatta il tuo agente per rinnovare in tempo per un uso normale.",
    "Expired": "Scaduto",
    "ExpiredWorkstation": "Il tuo servizio di streaming è scaduto, contatta il tuo agente per rinnovare in tempo.",
    "admin": "Amministratore:",
    "serviceState": "Servizio di streaming media:",
    "serviceStateLIST": "Servizio di streaming media",
    "ValidityPeriod": "Periodo di validità:",
    "ValidityPeriodLIST": "Periodo di validità",
    "Trial": "Prova",
    "Permanent": "Permanente",
    "AnnualBilling": "Fatturazione annuale",
    "mediaValidityPeriod": "Periodo di validità:",
    "mediaValidityPeriodLIST": "Periodo di validità",
    "contactInformation": "Dettagli di contatto (per il promemoria di rinnovo del servizio di streaming media)",
    "company": "Nome dell'azienda:",
    "email": "Email:",
    "phone": "Telefono:",
    "StartDate": "Data di inizio",
    "EndDate": "Data di fine",
    "To": "A",
    "TerminalName": "Nome utente finale",
    "Competence": "Amministratore",
    "operate": "Operare",
    "statusFilter": "Filtro stato",
    "disableStreaming": "Sei sicuro di voler disabilitare il servizio di streaming?",
    "enableStreaming": "Sei sicuro di voler abilitare il servizio di streaming?",
    "disableStreamingContent": "Quando il servizio di streaming è disabilitato, il gruppo non potrà utilizzare le relative funzioni di trasmissione e trasmissione in diretta.",
    "enableStreamingContent": "Si prega di modificare il periodo di validità per i gruppi con servizio di streaming scaduto.",
    "search": "Inserisci nome dell'organizzazione",
    "optionsYearZero": "Si prega di scegliere",
    "optionsYearOne": "Un anno",
    "optionsYearTwo": "Due anni",
    "optionsYearThree": "Tre anni",
    "dialogName": "Nome:",
    "detTitle": "Eliminare il gruppo comporterà l'eliminazione di tutto il contenuto al suo interno.",
    "groupDelTitle": "Sei sicuro di voler eliminare questo gruppo?",
    "delTitle": "Eliminare?",
    "delTitleContent": "I contenuti selezionati verranno eliminati dal database. Questa operazione non può essere annullata. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "copySuccess": "Il contenuto è stato copiato negli appunti.",
    "copyError": "Il browser non supporta la copia automatica",
    "error1200": "Nome gruppo duplicato",
    "error1201": "Duplicazione del gruppo o ID gruppo",
    "error1202": "Numero massimo di dispositivi connessi superato",
    "error1203": "Nome utente duplicato",
    "error1204": "Esiste un gruppo con lo stesso nome allo stesso livello",
    "error1210": "Inserisci la password dell'amministratore",
    "warningGroup": "Scegli un gruppo!",
    "warningTerminal": "Il gruppo terminale non può creare sottogruppi!",
    "account": "Account duplicato",
    "titleOrganization": "Nota: Il prefisso dell’account è definito a livello di organizzazione. Tutti gli account utente di questa organizzazione condivideranno lo stesso prefisso.",
    "all": "Tutti"
  },
  "userMge": {
    "nickName": "Soprannome",
    "contentWithBrand": "Inserisci la marca o il modello",
    "contentwithIp": "Cerca per nome del dispositivo o indirizzo IP.",
    "btnAdd": "Nuovo Utente",
    "btnDelete": "Elimina",
    "btnDownload": "Scarica Modello",
    "btnImport": "Importazione in Massa",
    "btnExport": "Scarica",
    "btnDisable": "Disabilita",
    "btnEnable": "Abilita",
    "accountType": "Filtra per Ruolo",
    "organizationName": "Filtra per Gruppo",
    "content": "Cerca",
    "systemAccount": "ID Utente",
    "idCardNumber": "ID Dipendente",
    "customizeAccount": "Account Personalizzato",
    "userName": "Nome",
    "licenseNum": "Numero di Licenza",
    "phone": "Telefono",
    "email": "Email",
    "role": "Ruolo",
    "status": "Stato",
    "affiliatedOrganization": "Gruppi",
    "roleTypeList1": "Utente Generale",
    "roleTypeList2": "Studente",
    "roleTypeList3": "Genitore",
    "roleTypeList101": "Amministratore Agente",
    "roleTypeList102": "Amministratore",
    "roleTypeList301": "Super Admin",
    "userStatus1": "Attivo",
    "userStatus2": "Bloccato",
    "userStatus3": "Elimina",
    "operate": "Azioni",
    "dialogName": "Nickname:",
    "dialogUserName": "ID Utente:",
    "dialogUserNameDefined": "Nome Utente:",
    "dialogPassword": "Password:",
    "dialogID": "ID Dipendente:",
    "dialogRole": "Ruolo:",
    "dialogEmail": "Email:",
    "dialogPhone": "Telefono:",
    "dialogGroup": "Gruppo:",
    "addUser": "Nuovo Utente",
    "editUser": "Modifica Utente",
    "addSuccess": "Aggiunto con Successo!",
    "addError": "Aggiunta Fallita!",
    "editSuccess": "Modifica Avvenuta con Successo!",
    "editError": "Modifica Fallita!",
    "delSuccess": "Eliminato con Successo!",
    "delError": "Eliminazione Fallita!",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "tableDel": "Elimina",
    "tableEdit": "Modifica",
    "selectRoles": "Seleziona Ruoli",
    "delTitle": "Eliminare?",
    "delTitleContent": "I contenuti selezionati saranno eliminati dal database. Questa operazione non può essere annullata. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "titleRealNameRq": "Questo campo deve essere compilato",
    "titleRealNameFormat": "Scegli un nome utente che contenga solo lettere e numeri.",
    checkPasswordTitleTwo: 'Imposta una password di almeno 6 caratteri, includendo lettere e numeri. I caratteri speciali sono consentiti (senza restrizioni).',
    checkPasswordTitle: 'La password deve contenere almeno 6 caratteri e non può essere composta solo da numeri',
    "titlePhoneFormat": "Il telefono può contenere solo numeri, () + e -.",
    "phoneFilled": "Il telefono deve essere compilato.",
    "titleEmaileFormat": "Errore nel formato dell'email.",
    "emaileFilled": "L'email deve essere compilata.",
    "titlUserNameDefinedNub": "Il nome utente non può superare i 30 caratteri",
    "titlRealNameNub": "Il nome non può superare i 30 caratteri.",
    "titlRealNameField": "Il nome deve essere compilato.",
    "thisPasswordField": "La password deve essere compilata.",
    "titlPassWordNub": "La password deve essere tra 6 e 30 caratteri",
    "enableStatus": "Abilita Utente",
    "stopStatus": "Disabilita Utente",
    "enableContent": "Sei sicuro di voler abilitare l'utente/i?",
    "stopContent": "Sei sicuro di voler disabilitare l'utente/i?",
    "error1400": "Il nome utente esiste già, prova di nuovo",
    "error1401": "ID Utente già esistente e l'operazione è fallita!",
    "error1402": "Il gruppo non esiste, importazione fallita!",
    "error1403": "I dati sono errati",
    "error1404": "Permessi insufficienti",
    "selUser": "Seleziona un utente!",
    "error1405": "Impossibile ottenere il ruolo",
    "error1406": "Il formato dei dati dell'utente importato è errato",
    "error1407": "L'email esiste già e l'operazione è fallita.",
    "error1408": "Il telefono esiste già e l'operazione è fallita.",
    "error1900": "Il parametro richiesto è vuoto",
    "error1610": "Per favore usa il ruolo di amministratore terminale per eseguire le operazioni relative",
    "errorOrgIdList": "Il gruppo non può essere vuoto!",
    "Bindsucceeded": "Collegamento riuscito",
    "Bindfailed": "Collegamento fallito",
    "tableuserName": "Nome Utente",
    "titleDevice": "Dispositivo",
    "bindDevice": "Dispositivo collegato",
    "Bindcontrollable": "Collegare dispositivo controllabile ora?"
  },
  "devicesMge": {
    mustChooseOne: 'Quando il telecomando intelligente è selezionato, deve essere scelto almeno un comando di controllo',
    customName: 'Nome personalizzato',
    "testAcCode": "Test nuovo codice di controllo A/C",
    "Online": "Online",
    "Offline": "Offline",
    "unBindConfirm": "Conferma per dissociare Serial",
    "unBindConfirm485": "Conferma per dissociare RS485",
    "notYetBoundRS232": "Il dispositivo non è ancora associato a un codice Serial. Puoi andare su Dispositivo > Codice di Controllo Serial per aggiungerlo.",
    "RsFollowingFunctions": "è possibile ottenere le seguenti funzioni tramite i codici Serial:",
    "Unbind": "Dissociare",
    "Limit255": "Il nome del file contiene un massimo di 255 caratteri",
    "clear": "Pulisci",
    "equipName": "Nome dispositivo",
    "equipType": "Tipo",
    "selectField": "Seleziona file",
    "dialogTip": "*Se la casella di input a destra è vuota, il contenuto a sinistra viene visualizzato per default",
    "dialogTipSingle": "*Se un dispositivo singolo non è nominato, seguirà il nome \"TUTTI\"",
    "cantDelTemplateOne": "Il CBX di ",
    cantDelTemplateTwo: 'Il CBX del dispositivo "{deviceName}" è un modello. Sei sicuro di volerlo eliminare?',
    "templateTitle": "Sostituzione modello",
    "templateContentOne": "Il nome del dispositivo \"",
    "templateContentTwo": " è stato impostato come modello CBX comune. Sei sicuro di voler impostare il dispositivo attuale come modello?",
    "vcbNoTemplateNoSave": "Impossibile salvare senza modello",
    "vcbAcControl": "Seleziona un dispositivo A/C",
    "vcbRemoteControl": "Seleziona un dispositivo di controllo remoto",
    "vcbPOWERControl": "Controllo potenza",
    "vcbRS232Control": "Controllo Serial",
    "vcbIRControl": "Controllo IR",
    "vcbSetting": "Impostazioni CBX",
    "editVcb": "Modifica CBX",
    "vcbName": "Nome CBX",
    "iot": "Controllo CBX",
    "saveAsTemplate": "Salva come modello",
    saveAsTemplatereplenish: 'Seleziona più dispositivi per utilizzare questo modello nel Centro di controllo',
    "Upload": "Carica",
    "Select": "Seleziona",
    "InputDeviceID": "Inserisci ID dispositivo",
    "editNameTips": "* Il contenuto a sinistra viene visualizzato di default mentre la casella di input a destra è vuota.",
    "_RS232A": "Interfaccia Uno",
    "_RS232B": "Interfaccia Due",
    "institutionDirectory": "Directory istituzionale",
    "projectionScreenLinkageSetting": "Impostazione controllo schermo di proiezione",
    "screenLiftingLinkageDisplaySwitch": "Controllo schermo di proiezione e sincronizzazione con display:",
    "stopLinkage": "Disabilita (Controlla separatamente lo schermo di proiezione)",
    "Enable": "Abilita (Sincronizza il controllo dello schermo di proiezione e del display)",
    "btnAddDevice": "Aggiungi dispositivo",
    "btnImportDevice": "Importazione massiva dispositivo",
    "btnDel": "Elimina",
    "btnEdit": "Modifica",
    "tableIpAddress": "Indirizzo IP",
    "MACAddress": "Indirizzo MAC",
    "firmwareVersion": "Versione del firmware",
    "NA": "N/A",
    "tableDeviceName": "Nome dispositivo",
    "tableStatus": "Stato",
    "tableVideoSwitch": "Commutatore video",
    "tableAudio": "Distribuzione A/V",
    "tablePowerControl": "Controllo potenza",
    "tableRS232": "Controllo seriale",
    "tableIR": "Controllo IR",
    "tableRFIDCard": "Carta IC",
    "tableControlPanel": "Pannello di controllo",
    "tableOrganization": "Gruppi",
    "tableActions": "Azioni",
    "dialogAddTitle": "Aggiungi dispositivo",
    "dialogEditTitle": "Modifica dispositivo",
    "dialogBatchAddTitle": "Aggiunta massiva dispositivo",
    "dialogBatchEditTitle": "Modifica massiva dispositivo",
    "btnCancel": "Annulla",
    "Devices": "Dispositivi:",
    "ProjectorCode": "Codice Serial:",
    "Group": "Gruppo:",
    "btnBatchAdd": "Aggiunta massiva",
    "delTitle": "Eliminare?",
    "delTitleContent": "I componenti selezionati saranno eliminati dal database. Questa operazione non può essere annullata. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "addError": "Aggiunta fallita!",
    "editSuccess": "Modifica riuscita!",
    "editError": "Modifica fallita!",
    "delSuccess": "Eliminazione riuscita!",
    "delError": "Eliminazione fallita!",
    "content": "Ricerca",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "tableDel": "Elimina",
    "tableEdit": "Modifica",
    "selectRoles": "Seleziona ruoli",
    "selectType": "Seleziona un tipo",
    "selectDevices": "Seleziona un dispositivo",
    "titleRealNameRq": "Questo campo deve essere compilato",
    "titleRealNameNub": "meno di 100 lettere",
    "titlPassWordNub": "meno di 15 lettere",
    "error1900": "Il parametro accessibile è vuoto",
    "error2000": "Superato il numero massimo di dispositivi connessi",
    "error2001": "Il codice del dispositivo importato è errato o non è stato ancora inserito nel sistema.",
    "error2002": "Nome dispositivo duplicato importato",
    "error2003": "L'ID dispositivo importato è già stato utilizzato",
    "error2004": "Errore nei dati importati",
    "error2005": "Il nome del marchio o del modello è duplicato rispetto ai dati esistenti nel sistema; si prega di rinominare il marchio o il modello.",
    "error2008": "Questo dispositivo è già associato a un altro gruppo",
    "notDevicesName": "Il nome del dispositivo non può essere vuoto",
    "notDevicesNO": "L'ID del dispositivo non può essere vuoto",
    "dialogDevicesName": "Nome dispositivo:",
    "dialogDevicesID": "ID dispositivo:",
    "dialogProjectorCode": "Codice Serial:",
    "dialogGroup": "Gruppo:",
    "dialogSel": "Per favore scegli",
    "errorOrgIdList": "Il gruppo non può essere vuoto!",
    "errorDevicesName": "Il nome del dispositivo non può essere vuoto!",
    "errorDevicesNo": "L'ID del dispositivo non può essere vuoto!",
    "dialogTiltleDevices": "Dispositivi:",
    "uploadSuccess": "Caricamento riuscito",
    "addSuccess": "Aggiunta riuscita",
    "ChooseGroups": "Scegli i gruppi",
    "ChooseIcon": "Scegli icona",
    "dialogDevicesTitle": "Le impostazioni del parametro sono applicate ai seguenti dispositivi",
    "backDevice": "Indietro",
    "bootSetting": "Opzioni di avvio",
    "nmpOpenSetting": "Impostazioni accensione",
    "npsOpenSetting": "Impostazioni accensione",
    "nmpPowerSettings": "Impostazioni di potenza",
    "npsPowerSettings": "Impostazioni di potenza",
    "nmpInterfaceSettings": "Impostazioni interfaccia",
    "npsInterfaceSettings": "Impostazioni interfaccia",
    "nmpDefaultChannel": "Impostazioni canale predefinito",
    "nmpCloseSetting": "Impostazioni spegnimento",
    "npsCloseSetting": "Impostazioni spegnimento",
    "SwipeToStart": "Abilita blocco (Tocca la carta per sbloccare)",
    "ControlPanelToStart": "Disabilita blocco (Operazione illimitata)",
    "Display": "Display",
    "External": "Esterno",
    "startingUpMethod": "Abilita/disabilita blocco pannello:",
    "startWith": "Avvia con:",
    "nmpstartWith": "Accensione sincronizzata:",
    "nmpcloseWith": "Spegnimento sincronizzato:",
    "RS232Tip": "Quando l'alimentazione principale viene spenta, un totale di 5 interfacce Serial, inclusi Serial e fino a 4 CBX, riceveranno il relativo codice di spegnimento.",

    startPowerTip: 'All’avvio, tutti i dispositivi collegati alle interfacce di alimentazione del CBX vengono attivati.',
    startAirTip: 'All’avvio, tutti i condizionatori associati vengono accesi tramite infrarossi del dispositivo/CBX.',
    startIrTip: 'All’avvio, viene inviato un comando di collegamento tramite IR del dispositivo/CBX (es. discesa dello schermo, accensione del proiettore).',
    startRSTip: 'All’avvio, viene inviato un comando di accensione tramite l’interfaccia Serial del dispositivo/CBX.',
    CloseDisplayTip: 'I dispositivi collegati all’interfaccia DISPLAY si spengono automaticamente quando il NDP/NMP viene spento. Questa impostazione è gestita dal firmware e non può essere modificata via software.',
    CloseExternalTip: 'I dispositivi collegati all’interfaccia EXTERNAL si spengono automaticamente quando il NDP/NMP viene spento. Questa impostazione è gestita dal firmware e non può essere modificata via software.',
    ClosePowerTip: 'Allo spegnimento, tutti i dispositivi collegati alle interfacce di alimentazione del CBX vengono disattivati.',
    CloseAirTip: 'Allo spegnimento, tutti i condizionatori associati vengono spenti tramite infrarossi del dispositivo/CBX.',
    CloseIrTip: 'Allo spegnimento, viene inviato un comando di collegamento tramite IR del dispositivo/CBX (es. salita dello schermo, spegnimento del proiettore).',
    CloseRSTip: 'Allo spegnimento, viene inviato un comando di spegnimento tramite l’interfaccia Serial del dispositivo/CBX.',
    npsOpenRS232Tip: "Quando l'alimentazione principale è accesa, le due porte seriali dell'NPS riceveranno i corrispondenti codici di comando di accensione.",
    "npsRS232Tip": "Quando l'alimentazione principale viene spenta, le due interfacce Serial di NPS riceveranno i relativi codici di spegnimento.",
    "useCardTip": "Dopo lo sblocco della carta, l'alimentazione dei dispositivi verrà attivata automaticamente.",
    "npsCardTip": "Dopo lo sblocco della carta, l'alimentazione principale dei dispositivi verrà attivata automaticamente.",
    "PowerOutageHandling": "Gestione dell'interruzione di corrente",
    "PowerOutageHandTip": "Per un accesso continuato durante interruzioni di corrente impreviste, scegli \"Sblocca in caso di interruzione di corrente\". Altrimenti, seleziona \"Blocca in caso di interruzione di corrente\" per limitare l'accesso.",
    "acSetting": "Impostazioni A/C",
    "ChooseType": "Tipo di dispositivo",
    "ChooseBrand": "Seleziona una marca",
    "ChooseModel": "Seleziona un modello",
    "btnConnectingTest": "Test di connessione",
    "LockSetting": "Impostazioni serratura elettrica",
    "ElectricLockType": "Tipo di serratura elettrica:",
    "PowerUNLOCK": "Sblocca in caso di interruzione di corrente",
    "PowerLOCK": "Blocca in caso di interruzione di corrente",
    "none": "Nessuno",
    "oddParity": "Parità dispari",
    "EvenParity": "Parità pari",
    "LastSetting": "Ultima impostazione",
    "ElectricLockClosing": "Chiusura serratura elettrica:",
    "manualSwitch": "Interruttore manuale",
    "Auto": "Auto (in)",
    "projectorSetting": "Selezione dispositivo e associazione",
    "baudRate": "Velocità di trasmissione",
    "Parity": "Parità",
    "ON": "ACCENSIONE",
    "OFF": "SPEGNIMENTO",
    "Channel1": "Canale 1",
    "Channel2": "Canale 2",
    "PowerOffDelay": "Ritardo spegnimento",
    "second": "s",
    "DefaultChannel": "Canale predefinito",
    "HDMIA": "HDMI out A:",
    "HDMIB": "HDMI out B:",
    "HDMIC": "HDMI out C:",
    "btnSaveApply": "Salva e applica su...",
    "btnSave": "Salva",
    "btnCustomize": "Personalizza",
    "ACIsPowerTitle": "Controlla se l'A/C è acceso?",
    "ACIsPowerContent": "Per favore spegni l'A/C prima del test. Se non si accende correttamente, assicurati che la marca e il modello dell'A/C siano corretti.",
    "btnNextModel": "No, prova il modello successivo",
    "btnYes": "Sì",
    "errorConnecting": "Test di connessione fallito",
    "hot": "HOT",
    "_MAGNETICLOCK": "Serratura elettronica",
    "_AIR": "Aria condizionata",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Impostazioni controllo IR",
    "acControlTitle": "Seleziona un dispositivo A/C:",
    "acControlTitleNew": "Dispositivo A/C",
    "intelligentControlTitle": "Seleziona un dispositivo di controllo remoto:",
    "intelligentControlTitleNew": "Dispositivo di controllo remoto",
    "btnACControlCode": "Identifica nuovo codice di controllo A/C",
    "btnAddRemoteControl": "Nuovo codice di controllo remoto",
    "ACControlCodeTitle": "Identifica codice di controllo A/C",
    "ACControlCodeseft1": "Identifica codice",
    "ACControlCodeseft2": "Aggiungi informazioni",
    "btnStartIdentify": "Avvia",
    "Identifysuccess": "Identificazione riuscita!",
    "BeingIdentify": "Analizzando...",
    "acBrand": "Marca A/C",
    "acModel": "Modello A/C",
    "IdentifyFailureTitle": "Impossibile trovare il codice",
    "IdentifyFailureContent": "L'identificazione è fallita, questo modello non è attualmente supportato. Prova con il telecomando",
    "btnTryAgain": "Riprova",
    "btnJump": "Vai al telecomando",
    "ACrideo": "A/C",
    "ortherRideo": "Altri dispositivi",
    "btnBack": "Indietro",
    "btnSortOut": "Vai a modifica",
    "remoteControlSeft1": "Seleziona tipo dispositivo",
    "remoteControlSeft2": "Impara codice",
    "remoteControlSeft3": "Aggiungi informazioni",
    "addRemoteControlError": "Siamo spiacenti, non è possibile imparare altri codici. Per favore modifica prima i codici di controllo remoto esistenti",
    "btnPrevious": "Precedente",
    "btnNextStep": "Successivo",
    "remoteControlErrorTitle": "Impossibile imparare il codice",
    "remoteControlErrorContent1": "1. Il trasmettitore a infrarossi non è bloccato",
    "remoteControlErrorContent2": "2. Nessuna forte interferenza luminosa intorno al ricevitore",
    "remoteControlErrorContent3": "3. Il trasmettitore a infrarossi è installato correttamente",
    "remoteControlErrorContent4": "4. Il telecomando funziona correttamente",
    "deviceItem1": "A/C",
    "deviceItem2": "Proiettore",
    "deviceItem3": "TV",
    "deviceItem4": "Ventilatore",
    "deviceItem5": "Luce",
    "deviceItem6": "Altri",
    "deviceItem7": "Pannello piatto interattivo",
    "deviceItem8": "Sistema di registrazione lezioni",
    "deviceItem9": "Telecamera PTZ",
    "RS232protocol": "Protocollo Serial:",
    "btnRemoteControl": "Inizia a imparare",
    "BeingIdentify1": "Analizzando...",
    "Identifysuccess1": "Successo",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Ventilatore",
    "controllerType5": "Luce",
    "controllerType9": "Altri",
    "rqRemoteControlCode": "Per favore inserisci il nome del codice di controllo remoto",
    "rqBrand": "Per favore inserisci la marca dell'A/C",
    "rqModel": "Per favore inserisci il modello dell'A/C",
    "error2016": "Il nome del telecomando è duplicato, per favore inserisci un altro",
    "RS232Setting": "Impostazione codice seriale",
    "IR232Setting": "Impostazione IR",
    "SystemError": "Errore di sistema. Per favore riprova",
    "conditionerCodeContent": "Non trovo il codice dell'aria condizionata, per favore riprova",
    "remoteControlCodeContent": "Non trovo il codice del telecomando, per favore riprova",
    "btnRetry": "Riprova",
    "Bindusers": "Associa utente",
    "tablebinduser": "Associa utenti",
    "Refresh": "Rinfresca",
    "Binduserlable": "Associare gli utenti che possono controllare il dispositivo ora?",
    "SaveApplySuccessfully": "Salva e applica con successo",
    "DeviceType": "Tipo:",
    "tableDeviceType": "Tipo",
    "empty": "È vuoto.",
    "sendCommand": "Invia più tardi",
    "enable": "abilita",
    "disable": "disabilita",
    "SYNCremoteControl": "SINCRONIZZARE con telecomando",
    "analysisfailed": "L'analisi è fallita, per favore riprova!",

    "CBX": {
      "powerSupplyON": "Accensione",
      "powerSupplyOFF": "Spegnimento",
      "powerVcrON": "Avvia Registrazione",
      "powerVcrOFF": "Interrompi Registrazione",
      "lockScreenON": "Blocca Attivo",
      "lockScreenOFF": "Blocca Disattivo",
      "childLockON": "Blocco Bambini Attivo",
      "childLockOFF": "Blocco Bambini Disattivo",
      "energySavingON": "Risparmio Energetico Attivo",
      "energySaving": "Risparmio Energetico",
      "energySavingOFF": "Risparmio Energetico Disattivo",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Altoparlante",
      "brightAdjustment": "Luminosità",
      "other": "Altre funzionalità...",
      "volumeExample": "Funzionalità completa del controllo Serial richiesta per la piena compatibilità con il sistema di registrazione.",
      "functionCode": "Funzione:",
      "Name": "Nome:",
      "controlCode": "Codice di Controllo:",
      "brand": "Marca:",
      "model": "Modello:",
      "errorBrandName": "La marca non può essere vuota!",
      "errorModelName": "Il modello non può essere vuoto!"
    }

  },
  "roleMge": {
    "role1": "Utente Generale",
    "role101": "Amministratore Agente",
    "role102": "Amministratore",
    "role4": "Ruolo Personalizzato",
    "roleNew": "Nuovo Ruolo",
    "btnAddRole": "Aggiungi Ruolo",
    "chooseUser": "Scegli Utente",
    "titleLevel": "Livello Proprietà Broadcast:",
    "titleSettings": "Impostazioni Permessi:",
    "btnSave": "Salva",
    "btnDelete": "Elimina",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "addSuccess": "Aggiungi con successo!",
    "addError": "Errore nell'Aggiungere!",
    "editSuccess": "Modifica con successo!",
    "editError": "Errore nella Modifica!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Errore nell'Eliminazione!",
    "V3_0_OrganizationManage": "Gestione Gruppi",
    "V3_0_UserManage": "Gestione Utenti",
    "V3_0_DeviceManage": "Gestione Dispositivi",
    "V3_0_CloudSpaceManage": "Gestione Cloud",
    "V3_0_OrganizationManage_View": "Visualizza",
    "V3_0_OrganizationManage_Edit": "Modifica",
    "V3_0_UserManage_View": "Visualizza",
    "V3_0_UserManage_Edit": "Modifica",
    "V3_0_DeviceManage_AddDevice": "Aggiungi Dispositivo",
    "V3_0_DeviceManage_Operating": "Operare",
    "V3_0_DeviceManage_Delete": "Elimina",
    "V3_0_DeviceManage_Edit": "Modifica",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestione cloud personale",
    "V3_0_CloudSpaceManage_PublicManage": "Gestione cloud pubblico",
    "V3_0_CloudSpaceManage_SpaceManage": "Assegnazione Spazio",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operare",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Visualizza",
    "V3_0_CloudSpaceManage_PublicManage_View": "Visualizza",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Carica",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Scarica",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Elimina File",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Modifica Cartella",
    "delTitle": "Eliminare?",
    "delTitleContent": "I contenuti selezionati verranno eliminati dal database. Questa operazione non può essere annullata. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "btnAdd": "Aggiungi Ruolo",
    "RoleName": "Nome Ruolo:",
    "ManageRange": "Ambito Gestione:",
    "ChooseUser": "Scegli Utente:",
    "PermissionSettings": "Impostazioni Permessi:",
    "BroadcastingPropertyLevel": "Livello Proprietà Broadcast",
    "ChooseGroups": "Scegli i Gruppi",
    "ChooseTheUser": "Scegli l'Utente",
    "deleleTitle": "Il nuovo ruolo non è stato salvato. Se esci, il ruolo verrà eliminato. Sei sicuro di voler uscire?",
    "Error1601": "Non puoi usare l'amministratore",
    "Error1602": "Impossibile ottenere il ruolo di permesso",
    "Error1603": "Solo gli amministratori hanno accesso a queste funzionalità",
    "Error1604": "Il nome del ruolo non può essere vuoto",
    "Error1605": "Il gruppo non può essere vuoto",
    "Error1606": "Questo ruolo esiste già",
    "Error1607": "Ruolo definito dal sistema, modifica non consentita",
    "Error1608": "Impostazione ruolo fallita",
    "Error1609": "Ruolo utente comune del sistema, modifica non consentita",
    "Error1610": "Per favore, usa il ruolo di amministratore del terminale per eseguire le operazioni correlate",
    "Error1611": "Non ha i permessi di ruolo correlati"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Compila il nome della funzione e il codice di controllo. Gli esempi di codice di controllo utilizzano il formato HEX.",
    "tipTwo": "2. Questa interfaccia serve solo per la configurazione dei comandi seriali di accensione/spegnimento. Vai a 'Gestione dispositivi / Dispositivi / Operazioni / Impostazioni alimentazione' per abilitare la funzione.",
    "tipFunctionOne": "1. Seleziona le funzioni comuni dall'elenco a discesa. Le icone corrispondenti verranno visualizzate sull'interfaccia di controllo seriale del pannello intelligente.",
    "tipFunctionTwo": "2. I comandi 'POWER ON' e 'POWER OFF' sono utilizzati per il collegamento seriale di accensione/spegnimento del dispositivo. Questa pagina configura solo i codici di controllo. Vai a 'Gestione dispositivi / Dispositivi / Operazioni / Impostazioni alimentazione' per abilitare la funzione di collegamento.",
    "ListRS232functions": "Elenco Funzioni Controllo Seriale",
    "Customizefunctionlist": "Personalizza l'elenco delle funzioni",
    "btnAddProjectorCode": "Aggiungi Codice Seriale",
    "btnDel": "Elimina",
    "inputSeach": "Cerca",
    "btnEdit": "Modifica",
    "cancel": "Pulisci",
    "confirm": "Conferma",
    "tableName": "Nome Codice",
    "tablersType": "Tipo di Dispositivo:",
    "tablersTypeTable": "Tipo di Dispositivo",
    "tableModel": "Modello",
    "tableBrand": "Marca",
    "tableActions": "Azioni",
    "dialogAddTitle": "Aggiungi Codice Serial",
    "dialogEditTitle": "Modifica Codice Serial",
    "brand": "Nome Marca:",
    "model": "Modello:",
    "baudRate": "Velocità di Trasmissione (Baud Rate):",
    "parity": "Parità:",
    "powerOn": "ON",
    "powerOff": "OFF",
    "pgrInput1": "Canale 1",
    "pgbInput2": "Canale 2",
    "delTitle": "Eliminare?",
    "delTitleContent": "I contenuti selezionati verranno eliminati dal database. Questa operazione non può essere annullata. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "content": "Cerca",
    "operate": "Azioni",
    "tableDel": "Elimina",
    "tableEdit": "Modifica",
    "addSuccess": "Aggiungi con successo!",
    "addError": "Errore nell'Aggiungere!",
    "editSuccess": "Modifica con successo!",
    "editError": "Errore nella Modifica!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Errore nell'Eliminazione!",
    "selectTitle": "Seleziona un Serial!",
    "selectCode": "Seleziona Serial",
    "none": "Nessuno",
    "oddParity": "Parità Dispari",
    "EvenParity": "Parità Piana"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Gestione Gruppi",
    "V3_0_UserManage": "Gestione Utenti",
    "V3_0_DeviceManage": "Gestione Dispositivi",
    "V3_0_CloudSpaceManage": "Gestione Spazio Cloud",
    "V3_0_OrganizationManage_View": "Visualizza",
    "V3_0_OrganizationManage_Edit": "Modifica",
    "V3_0_UserManage_View": "Visualizza",
    "V3_0_UserManage_Edit": "Modifica",
    "V3_0_DeviceManage_AddDevice": "Aggiungi Dispositivo",
    "V3_0_DeviceManage_Operating": "Operazioni",
    "V3_0_DeviceManage_Delete": "Elimina",
    "V3_0_DeviceManage_Edit": "Modifica",
    "V3_0_DeviceManage_RepairLog": "Registro Riparazioni",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestione Cloud Personale",
    "V3_0_CloudSpaceManage_PublicManage": "Gestione Cloud Pubblico",
    "V3_0_CloudSpaceManage_SpaceManage": "Gestione Spazio Cloud",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operazioni",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Visualizza",
    "V3_0_CloudSpaceManage_PublicManage_View": "Visualizza",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Carica",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Scarica",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Elimina",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Modifica",
    "delTitle": "Eliminare?",
    "delTitleContent": "I componenti selezionati verranno eliminati dal database. Questa operazione è irreversibile. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "content": "Cerca",
    "operate": "Azione",
    "tableDel": "Elimina",
    "tableEdit": "Modifica",
    "addSuccess": "Aggiunto con successo!",
    "addError": "Errore nell'Aggiunta!",
    "editSuccess": "Modifica con successo!",
    "editError": "Errore nella Modifica!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Errore nell'Eliminazione!",
    "selectTitle": "Seleziona Serial!"
  },
  "workstationMge": {
    "priorChoice": "Preferenze di Trasmissione:",
    "SpeedPriority": "Priorità Velocità",
    "SyncPriority": "Priorità Sincronizzazione Frame",
    "SpeedPriorityTip": "Dopo che i comandi di trasmissione AV sono inviati, i terminali Q-NEX possono eseguire il compito di riproduzione con un tempo di buffer più breve, circa 3-5 secondi. La priorità alla velocità è altamente raccomandata quando il Media Server funziona in LAN.",
    "SyncPriorityTip": "Dopo che i comandi di trasmissione AV sono inviati, i terminali Q-NEX possono eseguire il compito di riproduzione in modo sincrono con un tempo di buffer di circa 8-12 secondi.",
    "btnAddMedia": "Aggiungi Media Server",
    "btnBack": "Indietro",
    "tableMediaLibId": "ID Media Server",
    "tableMediaLibName": "Nome Media Server",
    "tableState": "Stato di Rete",
    "tableBindingUsers": "Utenti Associati",
    "tableLiveAddress": "Indirizzo Streaming",
    "tableAddress": "Indirizzo Trasmissione",
    "tableOperate": "Azioni",
    "tableDel": "Elimina",
    "tableEdit": "Modifica",
    "titleMediaStation": "Indirizzo Trasmissione",
    "titleLiveStation": "Indirizzo Streaming:",
    "radioPublic": "Pubblico",
    "radioPrivate": "Privato",
    "btnSave": "Salva",
    "titleUsers": "Utenti",
    "titleCanBe": "Possono Essere Associati",
    "titleHaveBeen": "Già Associati",
    "titleMore": "Aggiungere Altri?",
    "btnAdd": "Aggiungi",
    "content": "Cerca",
    "tableName": "Nome",
    "tableUserName": "Nome Utente",
    "operate": "Azioni",
    "affiliatedOrganization": "Gruppi",
    "dialogTitle": "Aggiungi Nuovo Media Server",
    "dialogTitleEdit": "Modifica Nuovo Media Server",
    "dialogItemName": "Nome:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Indirizzo Trasmissione:",
    "titleSelectUsers": "Seleziona Utenti",
    "selectMedia": "Seleziona Media",
    "delTitle": "Sei sicuro di voler eliminare?",
    "delMediaLibTitle": "Conferma Eliminazione?",
    "delTitleContent": "I contenuti selezionati verranno eliminati dal database. Questa operazione è irreversibile. Sei sicuro di voler continuare?",
    "delTitleMediaLibContent": "L'azione di eliminazione causerà la cancellazione dei dati rilevanti e non potrà essere revocata.",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "selectDevices": "Seleziona Dispositivi",
    "selectUser": "Seleziona Utenti",
    "addUser": "Aggiungi Utente",
    "editUser": "Modifica Utente",
    "addSuccess": "Aggiunto con Successo!",
    "addError": "Errore nell'Aggiunta!",
    "editSuccess": "Modifica con Successo!",
    "editError": "Errore nella Modifica!",
    "delSuccess": "Eliminato con Successo!",
    "delError": "Errore nell'Eliminazione!",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "error2500": "Numero massimo di dispositivi connessi al posto di lavoro attuale superato.",
    "DeviceName": "Nome Dispositivo",
    "AssociatedUserManagement": "Gestione Utenti Associati",
    "btnDel": "Elimina",
    "errorMsgId": "Impossibile trovare questo ID",
    "LiveStreaming": "Indirizzo Streaming:",
    "NoFoundMediaId": "Impossibile ottenere l'ID del Media Server",
    "AlreadyConnectedOrg": "Il Media Server è già associato a un'altra organizzazione",
    "AlreadyBoundMedia": "Questa organizzazione ha già associato un Media Server e non può associarne un altro",
    "DeleteSecondaryConfirmation": "I dati non possono essere recuperati dopo l'eliminazione del Media Server, si prega di confermare nuovamente."
  },
  "cloudDiskMge": {
    "totalStorage": "STOCCAGGIO TOTALE",
    "GetMore": "Ottieni di più",
    "StorageSpace": "Spazio di Archiviazione",
    "Adjustment": "Regolazione",
    "moreSpace": "Ottieni più spazio di archiviazione",
    "PublicStorage": "Archiviazione Pubblica",
    "PublicStorageUsed": "Archiviazione Pubblica Utilizzata",
    "PublicStorageLasted": "Archiviazione Pubblica Rimanente",
    "IndividualStorageUsed": "Archiviazione Personale Utilizzata",
    "IndividualStorageLasted": "Archiviazione Personale Rimanente",
    "storageSpace": "Regolazione dello Spazio di Archiviazione",
    "tableUserName": "Nome Utente",
    "tableUsedSpace": "Spazio Utilizzato",
    "tableAvailableSpace": "Spazio Disponibile",
    "tableActiveTime": "Ultimo Tempo Attivo",
    "tableOperate": "Azioni",
    "cleanup": "Nota per la pulizia",
    "IndividualStorageSpaceAdjustment": "Regolazione dello Spazio di Archiviazione Personale",
    "titleTotal": "Totale",
    "PublicDisk": "Cloud Pubblico",
    "IndividualDisk": "Cloud Personale",
    "PerUser": "Per Utente",
    "UsersInTotal": "Utenti Totali",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "addSuccess": "Aggiunto con Successo!",
    "addError": "Errore nell'Aggiunta!",
    "editSuccess": "Modifica con Successo!",
    "editError": "Errore nella Modifica!",
    "delSuccess": "Eliminato con Successo!",
    "delError": "Errore nell'Eliminazione!",
    "error3000": "L'operazione è fallita perché la dimensione totale dello spazio di archiviazione è stata superata.",
    "error3003": "Operazione fallita, verifica se è stato impostato un Media Server.",
    "IndividualStorage": "Archiviazione Personale",
    "NoteToCleanup": "Nota per la pulizia",
    "updatePersonalSuccess": "Il tuo spazio di archiviazione cloud è quasi pieno, per favore pulisci in tempo",
    "updatePersonalSuccess1": "Modificato e salvato con successo",
    "storageUsage": "Uso dello Spazio di Archiviazione Personale",
    "bindIndividualstorage": "Utenti autorizzati ad avere archiviazione cloud personale",
    "UserIndividualstorage": "Utenti che hanno già configurato l'archiviazione cloud personale",
    "Notificationsuccessfully": "Notifica inviata con successo",
    "Notificationfailed": "Errore nell'invio della notifica",
    "tableName": "Nome",
    "userID": "ID Utente"
  },
  "dashboard": {
    "exportPdf": "Esporta PDF",
    "or": "-",
    "warrantyCompletionRate": "Tasso di completamento della riparazione",
    "frequencyOfEachModule": "La percentuale di riparazione di ogni modulo funzionale",
    "repairHandling": "Stato di elaborazione della riparazione",
    "sourceSwitchInput": "Interruttore di ingresso",
    "micVol": "Volume microfono",
    "volumeSpeaker": "Volume altoparlante",
    "airAonditioner": "A/C",
    "Curtain": "Schermo proiettore",
    "remoteControlIntelligent": "Telecomando",
    "RS232Control": "Controllo Serial",
    "lockElectronic": "Serrature elettroniche",
    "Repairreportcompleted": "Riparato",
    "Totalnumberofrepairsreported": "Riparazioni totali",
    "Warrantycompletionrate": "Tasso di completamento della riparazione",
    "startDate": "Data di inizio",
    "endDate": "Data di fine",
    "year": "anno",
    "month": "mese",
    "dayTian": "giorno",
    "placeholderDate": "Seleziona Data",
    "placeholderDateTime": "Seleziona Ora",
    "devicesNub": "Dispositivi",
    "userNub": "Utenti",
    "powerNub": "Potenza(KW/H)",
    "storageUsed": "Spazio di Archiviazione Utilizzato(%)",
    "userLoginDevice": "Periodo di attività di login utente",
    "devicePowerConsumption": "Consumo giornaliero di energia di tutti i dispositivi",
    "externalDeviceUsageTime": "Utilizzo dispositivo esterno",
    "equipmentRunningTime": "Utilizzo dispositivo terminale",
    "cloudStorageSpace": "Utilizzo dello Spazio di Archiviazione",
    "powerConsumptionPort": "Consumo di Potenza per Ogni Porta di Alimentazione",
    "mostPopularFile": "File più Popolari",
    "commonFunctions": "Funzioni Comuni",
    "commonlyUsed": "Metodo di Broadcast Comunemente Utilizzato",
    "fileName": "Nome File",
    "usageCount": "Conteggio di Utilizzo",
    "electricityConsumption": "Consumo di Energia",
    "publicStorageUsed": "Spazio di Archiviazione Pubblico Utilizzato",
    "publicStorageLasted": "Spazio di Archiviazione Pubblico Rimanente",
    "individualStorageUsed": "Spazio di Archiviazione Individuale Utilizzato",
    "individualStorageLasted": "Spazio di Archiviazione Individuale Rimanente",
    "notification": "Notifica",
    "audioBroadcast": "Broadcast Audio",
    "videoBroadcast": "Broadcast Video",
    "ac": "A/C",
    "hDMISwitch": "Interruttore HDMI",
    "powerControl": "Controllo Potenza",
    "powercontrol": "Controllo Potenza",
    "Lock": "Blocco",
    "volumeAdjust": "Regolazione Volume",
    "projectionScreen": "Schermo Proiettore",
    "today": "Oggi",
    "yesterday": "Ieri",
    "thisWeek": "Questa settimana",
    "lastWeek": "Settimana scorsa",
    "lastMonth": "Ultimo mese",
    "thisMonth": "Questo mese",
    "times": "Volte",
    "usage": "Conteggio di Utilizzo",
    "eachrTitle": "Minuti",
    "total": "Totale",
    "NMPSystemissue": "Problema di sistema NMP",
    "displayPower": "Problema di dispositivo esterno NMP",
    "externalPower": "Problema di sistema MBX",
    "screen": "Problema di dispositivo esterno MBX",
    "TotalRepairs": "Riparazioni Totali",
    "Repaired": "Riparato",
    "Unrepaired": "Non Riparato",
    "day": "GIORNO",
    "Minutes": "Minuti",
    "powerConsumption": "Minuti",
    "Date": "Data",
    "kw": "KW",
    "month1": "LUN",
    "month2": "MAR",
    "month3": "MER",
    "month4": "GIO",
    "month5": "VEN",
    "month6": "SAB",
    "month7": "DOM",
    "enmonth1": "Gen",
    "enmonth2": "Feb",
    "enmonth3": "Mar",
    "enmonth4": "Apr",
    "enmonth5": "Mag",
    "enmonth6": "Giu",
    "enmonth7": "Lug",
    "enmonth8": "Ago",
    "enmonth9": "Set",
    "enmonth10": "Ott",
    "enmonth11": "Nov",
    "enmonth12": "Dic",
    "noData": "Nessun dato"
  },
  "input": {
    "fivedigits": "Inserisci un intero positivo entro 5 cifre",
    "titlUserNameField": "Questo nome utente deve essere compilato.",
    "thisField": "Questo campo deve essere compilato.",
    "ChooseGroup": "Scegli gruppo",
    "placeholder": "Seleziona",
    "placeholder_type": "Seleziona i tipi di controllo del dispositivo",
    "titlRealNameField": "La password deve essere compilata.",
    "thisPasswordField": "La password deve essere compilata.",
    "titlPassWordNub": "meno di 15 lettere",
    "Post": "Solo numeri",
    "passwordNoChinese": "Questo campo di input non può essere riempito con caratteri cinesi"
  },
  "transfer": {
    "all": "Tutti",
    "Choose": "Scegli",
    "Selected": "Selezionato",
    "Subordinate": "Subordinato"
  },
  "setting": {
    limitPngGif: 'Sono supportati solo i formati PNG / GIF',
    limit3M: 'La dimensione dell’immagine non deve superare 3 MB',
    setting_door_Wallpaper_text: 'Dimensione immagine consigliata: 1280x800, formato PNG o GIF',

    "reduction": "Ripristina",
    "limitJpg": "L'immagine del profilo caricata può essere solo in formato PNG!",
    "limit2M": "La dimensione dell'immagine del profilo caricata non può superare i 2 MB!",
    "choseFile": "Seleziona il file",
    "textOne": "1. Immagine consigliata del LOGO: dimensioni 117*40, in formato PNG",
    "textTwo": "2. Dopo aver completato il caricamento, passa al Pannello Touch e assicurati che il Pannello Touch sia connesso a Internet, quindi fai clic sul logo originale per aggiornare.",
    "customizeLogo": "Impostazione del logo del pannello touch",
    "addSuccess": "Impostazione riuscita!",
    "settingIp": "Impostazione dell'IP di archiviazione file",
    "ServerIP": "Indirizzo IP del server:",
    "ServerPort": "Porta del server:",
    "btnSave": "Salva",
    "TimeZoneSetting": "Impostazione del fuso orario",
    "CurrentTime": "Ora corrente:",
    "CurrentTimeZone": "Fuso orario corrente:",
    "httpsSetting": "Archiviazione file:",
    "utcName": "Ora media di Greenwich UTC/GMT",
    "utc0": "Ora media di Greenwich, Regno Unito, Lisbona, Torshavn, Londra, Dublino, Edimburgo",
    "utc0_5": "",
    "utc1": "Europa centrale, Africa occidentale, Africa centrale, Germania, Irlanda, Francia, Amsterdam, Italia, Berlino, Roma, Spagna, Praga, Belgrado, Bruxelles, Parigi, Madrid, Tunisia, Gabon, Marocco",
    "utc1_5": "",
    "utc2": "Europa orientale, Africa centrale, Turchia, Israele, Sud Africa, Istanbul, Il Cairo, Atene, Damasco",
    "utc2_5": "",
    "utc3": "Africa orientale, Russia, Baghdad, Kuwait, Mosca, San Pietroburgo",
    "utc3_5": "Iran",
    "utc4": "Abu Dhabi, Tbilisi, Dubai, Mauritius, Port Louis",
    "utc4_5": "Afghanistan",
    "utc5": "Pakistan, Turkmenistan, Maldive, Uzbekistan, Armenia, Tagikistan, India, Mumbai, Nuova Delhi, Bangalore, Calcutta",
    "utc5_5": "India, Sri Lanka",
    "utc6": "Novosibirsk, Kirghizistan, Bangladesh, Bhutan",
    "utc6_5": "Isole Cocos, Australia, Vietnam",
    "utc7": "Thailandia, Bangkok, Hanoi, Giacarta",
    "utc7_5": "",
    "utc8": "Cina, Malesia, Filippine, Singapore, Taiwan Cina, Macao Cina, Hong Kong Cina",
    "utc8_5": "",
    "utc9": "Giappone, Corea del Sud, Tokyo, Seoul, Sapporo, Osaka, Timor Est",
    "utc9_5": "Ora standard centrale australiana",
    "utc10": "Australia, Vladivostok, Guam, Canberra, Melbourne, Sydney, Papua Nuova Guinea",
    "utc10_5": "Isola Lord Howe, Nuovo Galles del Sud, Australia",
    "utc11": "Isole Salomone, Isola Sachalin",
    "utc11_5": "Isola Norfolk, Australia",
    "utc12": "Nuova Zelanda, Auckland, Wellington, Figi, Nuova Zelanda, Nauru",
    "utc12_5": "",
    "utc13": "Capo Verde, Azzorre",
    "utc13_5": "",
    "utc14": "Georgia del Sud, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brasile, Santiago, El Salvador, Brasilia, Uruguay, Argentina, Suriname",
    "utc15_5": "Ora standard di Terranova",
    "utc16": "Venezuela, Bolivia, Paraguay, Cile",
    "utc16_5": "Venezuela",
    "utc17": "Ora orientale (USA e Canada), Colombia, Toronto, Ecuador, Perù, Cuba, New York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "Ora centrale degli Stati Uniti e del Canada, Città del Messico, Monterrey, Chicago, Houston, New Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Ora delle montagne, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Ora del Pacifico, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaska",
    "utc21_5": "Polinesia francese, Isole Marquesas",
    "utc22": "Hawaii",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Nome Dispositivo:",
    "Time": "Tempo:",
    "startDate": "Data di Inizio",
    "endedDate": "Data di Fine",
    "or": "-",
    "Problem": "Problema:",
    "btnSearch": "Cerca",
    "tableNO": "No",
    "tableDeviceName": "Nome Dispositivo",
    "tableGroup": "Gruppo",
    "tableStatus": "Stato",
    "tableDeliveredTime": "Tempo di Consegna",
    "tableSubmitter": "Inviato da",
    "tableUpdatingTime": "Tempo di Aggiornamento",
    "tableProblem": "Problema",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Risposta dell'Amministratore",
    "tableAttachment": "Allegato",
    "state0": "Consegnato",
    "state1": "In Lavorazione",
    "state2": "Completato",
    "Problem100": "TUTTI",
    "Problem0": "Problema del Sistema",
    "Problem1": "Problema del Dispositivo Esterno",
    "ProblemType": "",
    "ProblemType0": "Controllo Alimentazione",
    "ProblemType1": "Interruttore HDMI",
    "ProblemType2": "Microfono",
    "ProblemType3": "Altoparlante",
    "ProblemType4": "A/C",
    "ProblemType5": "Schermo del Proiettore",
    "ProblemType6": "Serratura Elettrica",
    "ProblemType7": "Broadcasting A/V",
    "ProblemType8": "Controllo IR",
    "ProblemType9": "Controllo Serial",
    "dialogDeviceName": "Nome Dispositivo",
    "dialogDeviceID": "ID Dispositivo",
    "dialogGroup": "Gruppo",
    "dialogSubmitter": "Inviato da",
    "dialogStatus": "Scegli stato",
    "dialogProblem": "Problema",
    "dialogNotes": "Note",
    "dialogRepairation": "Riparazione",
    "dialogInProcess": "In Lavorazione",
    "dialogCompleted": "Completato",
    "editSuccess": "Modifica riuscita!",
    "editError": "Errore nella modifica!",
    "problemRequired": "Si prega di selezionare un tipo di problema",
    "detailRequired": "Si prega di descrivere il problema in dettaglio",
    "statusRequired": "Si prega di scegliere lo stato del registro",
    "btnCancel": "Annulla",
    "DeliveredTime": "Tempo di Consegna",
    "UpdatingTime": "Tempo di Aggiornamento",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Risposta dell'Amministratore",
    "Note": "Nota",
    "Detail": "Dettagli",
    "controlPanel": "Pannello di Controllo",
    "DeviceType": "Tipo",
    "dialogDeliveredTime": "Tempo di Consegna",
    "Submitter": "Inviato da"
  },
  "remoteControl": {
    "QuickActionName": "Nome",
    "DeviceType": "Tipo",
    "Description": "Descrizione",
    "tableDescription": "Descrizione",
    "editRemoteControl": "Modifica Codice Telecomando",
    "QuickActionNameInput": "Nome",
    "DescriptionInput": "Descrizione",
    "save": "Salva",
    "Brand": "Marca",
    "Model": "Modello",
    "EditACControlCode": "Modifica Codice Controllo A/C",
    "acBrand": "Marca A/C",
    "acModel": "Modello A/C"
  },
  "card": {
    "btnAddCard": "Aggiungi Carta",
    "btnBatchAddCard": "Aggiungi Carte in Lotti",
    "tableCard": "Numero della Carta",
    "tableState": "Stato",
    "tableUser": "Utente Associato",
    "tableID": "Nome utente",
    "tableType": "Tipo di Carta",
    "tableFfective": "Data di Scadenza",
    "dialogCard": "Numero della Carta:",
    "dialogState": "Stato:",
    "dialogUser": "Utente Associato:",
    "dialogID": "Nome utente:",
    "dialogType": "Tipo di Carta:",
    "dialogFfective": "Data di Scadenza:",
    "dialogRemarks": "Note:",
    "dialogAddTitle": "Aggiungi Carta",
    "dialogEidtTitle": "Modifica Carta",
    "code2201": "Il formato del periodo di scadenza della carta è errato",
    "code2202": "Questa carta è già associata",
    "code2203": "Questo utente è già associato",
    "code2204": "Questa carta non è associata",
    "mastCard": "Carta Master",
    "regularCard": "Carta Generale",
    "permanent": "Permanente",
    "coxPermanent": "Permanente",
    "coxTime": "Per un determinato periodo di tempo",
    "tableDeviceName": "Nome del Dispositivo",
    "tableDeviceID": "ID del Dispositivo",
    "tableOperating": "Operazione",
    "tableOperatingTime": "Tempo di Operazione",
    "tableCardID": "Numero della Carta",
    "tableCardType": "Tipo di Carta",
    "tabluserName": "Nome Utente",
    "tabluserId": "ID Utente",
    "unlockPanel": "Sblocca Pannello",
    "unlock": "Sblocca Porta",
    "conAll": "Tutti",
    "btnEnable": "Abilita",
    "btnDisable": "Disabilita",
    "enableSuccess": "Abilitato con successo",
    "stopSuccess": "Disabilitato con successo",
    "enableError": "Errore nell'abilitare",
    "stopError": "Errore nel disabilitare",
    "batchCard": "Numero della Carta in Lotti:",
    "titlCardField": "Il numero della carta non può essere vuoto",
    "titlCardFieldFormat": "Solo lettere e numeri",
    "dialogBachAddTitle": "Aggiungi Carte in Lotti",
    "pleaseTryAgain1": "Numero della carta errato (NO. :",
    "pleaseTryAgain2": "), riprova"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/it.js